import React from "react";
import styled from "styled-components";
import { between, down, only, up } from "styled-breakpoints";
import settings from "@src/settings";
import { Props } from "./";
import getGridHeight from "@src/utils/getGridHeight";

const fontSize = settings.voiceGrid.fontSize;
const lineGap = settings.voiceGrid.lineGap;

export const Frame = styled.div<{ reverse: Props["reverse"] }>`
	display: flex;
	align-items: center;
	flex-direction: ${(props) => (!props.reverse ? "row" : "row-reverse")};
	margin-left: ${(props) => (props.reverse ? "3rem" : 0)};
	& > * {
		flex: 1 1 50%;
	}
	& > * + * {
		margin-${(props) => (!props.reverse ? "left" : "right")}: 2rem;
	}
	* + & {
		margin-top: ${fontSize + lineGap + (lineGap - fontSize) / 2}px;
	}
	${down("md")}{
		flex-direction: column-reverse;
		margin-left: 0;
		& > * + * {
			margin: 0;
		}
		& > *:last-child{
			margin-left: 3rem;
		}
		& > *:last-child:not(:first-child) {
			margin-bottom: ${fontSize + lineGap + (lineGap - fontSize) / 2}px;
		}
		* + & {
			margin-top: ${fontSize + lineGap + (lineGap - fontSize) / 2}px;
		}
	}
	${down("xs")}{
		& > *:last-child {
			margin-left: 0;
		}
	}
`;
export const Column = styled.div``;
export const ImgBox = styled.div`
	align-self: stretch;
	background-color: #ddd;
	border-radius: 14px;
	overflow: hidden;
	&:first-child {
		margin-left: 3rem;
	}
	${down("xs")} {
		&:first-child {
			margin-left: 0;
		}
	}
`;
